module.exports = __webpack_public_path__ + "static/media/mic-ss.9b6348d7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/mic-ss.png
 ** module id = 206
 ** module chunks = 0
 **/